import { GET_MY_PROFILES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Myprofiles {
    success: boolean;
    data: Data;
}
export interface Data {
    users?: UsersEntity[] | null;
}
export interface UsersEntity {
    profile: Profile;
    business: Business;
}
export interface Profile {
    mn: string;
    ln: string;
    pincode: string;
    fln: string;
    'dob-valid': boolean;
    fn: string;
    oid: string;
    pic: string;
    email: string;
    gen: string;
    'is-p': boolean;
    mobile: string;
    at: string;
    dob: string;
    uuid: string;
    'is-d': boolean;
    type: number;
    poid: string;
    'health-ids'?: string[] | null;
    'is-biz'?: boolean | null;
    as?: string | null;
    bloodgroup?: string | null;
}
export interface Business {
    business_id: string;
    name: string;
    logo: string;
    about?: string | null;
}

export default (): Promise<Myprofiles> => {
    return fetchWithRefresh(GET_MY_PROFILES).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed GET_DOC_ACCOUNTS: fetchMyProfiles' + res.status);
        }
    });
};
